import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../utils/apiConfig";
import React, { useEffect, useState } from "react";
import ErrorHandler from "../../utils/errorConfig";
import ApiServices from "../../service/apiService";
import {
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import config from "../../config.json";
import { Button } from "rsuite";
import { TestCourseModel } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { InfinitySpin } from "react-loader-spinner";

export interface TestCourseProps {
  testCourseDialogToggle?: Function;
  testCourseDialogValue?: boolean;
  courseIdValue: string;
}
export function TestCourse(props: TestCourseProps) {
  const accountInstance = Account.getInstance();
  const intl = useIntl();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [adminUserData, setadminUserData] = useState<any>();
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [selectedRowItem, setSelectedRowItem] = useState<any>();
  const [shareAlertDialog, setShareAlertDialog] = useState<boolean>(false);
  const [shareSuccessDialog, setShareSuccessDialog] = useState<boolean>(false);
  const [selectedChannel, setSelectedChannel] = useState("whatsapp");

  const [shareTestCourse, setShareTestCourse] = useState<TestCourseModel>({
    input: {
      accntId: "",
      body: {
        courseId: "",
        userId: "",
        channel: "",
      },
    },
    stateMachineArn: "",
  } as TestCourseModel);
  const [loader, setLoader] = React.useState<boolean>(false);
  console.log("loader value in search customer", loader);

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("inside test course dialog");
  console.log("row id value", selectedRowIndex);
  console.log("selected row item is", selectedRowItem);

  console.log("admin user data in test course", adminUserData);
  console.log("course id value", props.courseIdValue);

  console.log("state machine arn value", config.stateMachineArn);

  const toggleShareAlertDialog = () => {
    setShareAlertDialog(!shareAlertDialog);
  };
  const toggleShareSuccessDialog = () => {
    setShareSuccessDialog(!shareSuccessDialog);
  };
  const handleChannelChange = (event: any) => {
    setSelectedChannel(event.target.value);
    console.log("Selected channel: adfafaeraerfarawerawe", event.target.value);
  };
  const handleRadioChange = (item: any, index: number) => {
    setSelectedRowIndex(index);
    console.log("print the selected row value", item);
    setSelectedRowItem(item);
  };
  const handleShareCourse = async () => {
    if (selectedRowIndex === null) {
      toggleShareAlertDialog();
      return;
    }
    setLoader(true);
    let shareCourseBody = shareTestCourse;
    shareCourseBody.input.accntId = selectedRowItem.accntId;
    shareCourseBody.input.body.courseId = props.courseIdValue;
    shareCourseBody.input.body.userId = selectedRowItem.userId;
    shareCourseBody.input.body.channel = selectedChannel;
    shareCourseBody.stateMachineArn = config.stateMachineArn;

    let inputStringify;
    inputStringify = JSON.stringify(shareCourseBody.input);

    const payload = {
      input: inputStringify,
      stateMachineArn: shareCourseBody.stateMachineArn,
    };
    console.log("payload to pass", payload);

    console.log("share course body", shareCourseBody);

    console.log("share course body", shareCourseBody);
    console.log("share course stringify data", JSON.stringify(shareCourseBody));
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`coursemgmt/${props.courseIdValue}`, "POST", payload)
        .then((response: any) => {
          if (response) {
            console.log("Course shared successfully", response);
            toggleShareSuccessDialog();
          }
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  function convertRole(role: any) {
    switch (role) {
      case "tnt_superAdmin":
        return <FormattedMessage id="organization.superAdmin" />;
      case "tnt_contentCreator":
        return <FormattedMessage id="organization.contentCreator" />;
      case "tnt_reviewer":
        return <FormattedMessage id="organization.reviewer" />;
      case "tnt_admin":
        return <FormattedMessage id="organization.admin" />;
      case "tnt_L1Admin":
        return <FormattedMessage id="organization.l1Admin" />;
      case "tnt_courseScheduler":
        return <FormattedMessage id="organization.courseScheduler" />;
    }
  }
  useEffect(() => {
    setLoader(true);
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/customersadmin`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("admin data", data);
          const enabledAdminUsrs = data?.filter(
            (user: { status: string }) =>
              user.status ===
              intl.formatMessage({ id: "course.testCourse.enabled" })
          );
          console.log("print data role in get", data?.role);
          // setadminUserData(data);
          setadminUserData(enabledAdminUsrs);
        })
        .finally(() => {
          setLoader(false);
        });
    }
    // setLoader(false);
  }, []);
  return (
    <div>
      <div className="flex items-center justify-center">
        {loader && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20">
            <div>
              <div className="w-full h-full bg-transparent loader"></div>
              <div className="absolute top-1/3 left-1/2">
                <InfinitySpin
                  width="200"
                  color="var(--color-mk-primary-bright)"
                />
              </div>
            </div>
          </div>
        )}
        {shareAlertDialog && (
          <Dialog className="alertDialogue">
            <Alert
              description={intl.formatMessage({
                id: "course.testCourse.selectUser.initiateTest",
              })}
              buttonText={intl.formatMessage({ id: "users.buttonText.Ok" })}
              icon={"alertShape.png"}
              iconMsg={intl.formatMessage({ id: "iconMsgAlert" })}
              backgroundColor={"mk-orange"}
              onClick={() => {
                toggleShareAlertDialog();
              }}
            />
          </Dialog>
        )}
        {shareSuccessDialog && (
          <Dialog className="confirmSuccessDialogue">
            <Alert
              description={intl.formatMessage({
                id: "course.testCourse.shareSuccess",
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"successShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgSuccess",
              })}
              backgroundColor={"mk-bright-green"}
              onClick={() => {
                toggleShareSuccessDialog();
                if (props.testCourseDialogToggle) {
                  props.testCourseDialogToggle(!props.testCourseDialogValue);
                }
              }}
            />
          </Dialog>
        )}

        <div className="">
          <h4 className="font-semibold">
            {/* Select User To Test Course */}
            <FormattedMessage id="course.testCourse.selectUser"></FormattedMessage>
          </h4>
          <div className="mt-6 hide-scroll bg-transparent max-w-full flex overflow-x-auto space-x-7 pb-8 px-4">
            <div className="">
              <TableContainer component={Paper} className="noOutline">
                <Table size="small" className="tableBackground">
                  <TableHead className="table-header">
                    <TableRow>
                      <TableCell className="custom-header">
                        {/* Select */}
                        <FormattedMessage id ="course.testCourse.select"></FormattedMessage>
                        </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.firstName"></FormattedMessage>
                      </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.lastName"></FormattedMessage>
                      </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.mobileNumber"></FormattedMessage>
                      </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.emailID"></FormattedMessage>
                      </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.access"></FormattedMessage>
                      </TableCell>
                      <TableCell className="custom-header">
                        <FormattedMessage id="course.testCourse.status"></FormattedMessage>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adminUserData && adminUserData.length > 0 ? (
                      adminUserData?.map((item: any, index: number) => (
                        <TableRow
                          key={index}
                          className={
                            selectedRowIndex === index ? "selected" : ""
                          }
                        >
                          <TableCell>
                            <Radio
                              // checked={selectedRow?.id === item.id}
                              checked={selectedRowIndex === index}
                              onChange={() => handleRadioChange(item, index)}
                              value={index}
                              inputProps={{ "aria-label": `row-${index}` }}
                            />
                          </TableCell>
                          <TableCell className="">{item.fname}</TableCell>
                          <TableCell className="">{item.lname}</TableCell>
                          <TableCell className="">{item.phNo}</TableCell>
                          <TableCell className="">{item.email}</TableCell>
                          <TableCell className="">
                            {convertRole(item.role)}
                          </TableCell>
                          <TableCell className="">{item.status}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <div></div>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="pt-10"></div>
              <div className="">
                <h4 className="font-semibold">
                  {/* Select Delivery Channel */}
                  <FormattedMessage id="course.testCourse.selectDeliveryChannel"></FormattedMessage>
                </h4>
                <RadioGroup
                  row
                  aria-label="delivery-channel"
                  name="delivery-channel"
                  value={selectedChannel}
                  onChange={handleChannelChange}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    value="whatsapp"
                    control={<Radio size="small" />}
                    // label="WhatsApp"
                    label={
                      <span style={{ fontSize: "0.875rem" }}>
                        {/* WhatsApp */}
                        <FormattedMessage id="course.testCourse.whatsApp"></FormattedMessage>
                      </span>
                    }
                    sx={{ marginRight: "10px" }}
                  />
                  <FormControlLabel
                    value="teams"
                    control={<Radio size="small" />}
                    // label="Teams"
                    label={
                      <span style={{ fontSize: "0.875rem" }}>
                        <FormattedMessage id="course.testCourse.teams"></FormattedMessage>
                      </span>
                    }
                  />
                </RadioGroup>
              </div>

              <div className="flex justify-end gap-4 pt-3">
                <Button
                  className="buttonBackgroundColor"
                  onClick={handleShareCourse}
                >
                  {/* Initiate Test */}
                  <FormattedMessage id="course.testCourse.initiateTest"></FormattedMessage>
                </Button>

                <Button
                  // themeColor="primary"
                  className="buttonBackgroundColor"
                  onClick={() => {
                    if (props.testCourseDialogToggle) {
                      props.testCourseDialogToggle(
                        !props.testCourseDialogValue
                      );
                    }
                  }}
                >
                  {/* Cancel */}
                  <FormattedMessage id="course.testCourse.cancel"></FormattedMessage>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
